import { useTranslation } from "react-i18next";
import "./daKit.scss";
import DALayout from "../da-layout";
import { Breadcrumb, Button, Col, Form, Input, Row, Steps } from "antd";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { useLocation, useNavigate } from "react-router-dom";
import { isEmptyObject, validateInput } from "../../../../tools/tools";
import { useEffect } from "react";
import { useDealer } from "../../../../tools/api";
import { Roles } from "../../../../tools/services";
import { useDispatch, useSelector } from "react-redux";
const DAKit = () => {
  const [t] = useTranslation("global");
  const { checkKitNOForSW, reserveKitNo } = useDealer();

  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });

  const nav = useNavigate();
  const location = useLocation();
  const [frmKit] = Form.useForm();

  useEffect(() => {
    if (isEmptyObject(location?.state)) {
      nav(_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Valid);
    }
  }, []);
  const handleSubmit = async (values) => {
    let payload = {
      kitNo: values.kitNo,
      msisdn: location?.state?.daChange?.aptelMSIDSN,
    };
    let response = await checkKitNOForSW(payload);
    if (response && !response?.HasError) {
      payload = {
        kitNo: values.kitNo,
      };
      let resResev = await reserveKitNo(payload);
      if (resResev && !resResev.HasError) {
        if (_currentUser?.roles?.includes(Roles.Dealer_SimSwap_Can_PickupMethodOfReceipt)) {
          nav(_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Prefactor, {
            state: { daChange: location?.state?.daChange, purchase: location?.state?.purchase, kitNo: values?.kitNo },
          });
        } else {
          nav(_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Document, {
            state: { daChange: location?.state?.daChange, purchase: location?.state?.purchase, kitNo: values?.kitNo },
          });
        }
      }
    }
  };
  return (
    <>
      <DALayout>
        <div className="holder-top-of-page-content">
          <div className="g-hold-title-of-page">
            <Breadcrumb
              className="breadcrumbs"
              items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("deliveryArea.title") }]}
            />
            <div className="title-page">
              <h3>{t("deliveryArea.title")}</h3>
              <p></p>
            </div>
          </div>
        </div>
        <div className="g-layout-content">
          <Content className="g-layout-main da-container">
            <div className="g-format-page">
              <div className="g-body-format-page">
                <div className="g-format-steps">
                  <div className="holder-step">
                    <Steps
                      size="small"
                      className="step-wizard"
                      current={1}
                      items={[
                        {
                          title: "احراز هویت",
                        },
                        {
                          title: "شماره کیت جدید",
                        },
                        {
                          title: "سند",
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="da-kit-container">
                  <Form id="frmKit" form={frmKit} layout="vertical" onFinish={handleSubmit}>
                    <Row>
                      <Col xl={6} lg={8} md={10} sm={24} xs={24}>
                        <Form.Item
                          className="input-normal"
                          label="شماره کیت جدید"
                          name="kitNo"
                          rules={[validateInput({ validate: true, t: t, type: "number", length: 9 })]}
                        >
                          <Input autoComplete="off" dir="ltr" name="kitNo" placeholder="شماره کیت جدید را وارد کنید" showCount maxLength={9} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
              <div className="g-footer-format-page">
                <div className="holder-button">
                  <Button form="frmKit" key="submit" htmlType="submit" className="btn-normal btn-aptel">
                    مرحله بعدی
                  </Button>
                  <Button
                    onClick={() => nav(_adr.Root + _adr.DeliveryArea.Index + _adr.DeliveryArea.Delivery.Index + _adr.DeliveryArea.Delivery.Valid)}
                    className="btn-normal"
                  >
                    بازگشت
                  </Button>
                </div>
              </div>
            </div>
          </Content>
        </div>
      </DALayout>
    </>
  );
};

export default DAKit;
